import React, { useEffect, useState, useReducer, useRef } from "react";
import getData from "../Custome_Components/commonAPISelect";
import { IoCloseOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { RiAttachment2 } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import Button from '@mui/material/Button';
import { toast } from "react-toastify";

const styles = {
    Attachment: {
        position: "relative",
    },
    FileList: {
        display: "flex",
        flexDirection: "column",
        marginTop: "10px",
        marginBottom: "0px",
        gap: "10px",
    },
    FileItem: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #E3E3E3",
        padding: "10px 14px",
        position: "relative",
        borderRadius: "4px",
        fontSize: "14px",
    },
    FileName: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    CloseIcon: {
        cursor: "pointer",
        position: "absolute",
        right: "10px",
        color: "red",
        top: "50%",
        transform: "translateY(-50%)",
    },
    AttachmentIcon: {
        width: "20px",
        height: "20px",
        cursor: "pointer",
        marginTop: "10px",
    },
    AttachmentText: {
        color: "black",
        fontWeight: "500",
    },
};

const departmentReducer = (state, action) => {
    switch (action.type) {
        case "departmentIDPK":
            return {
                ...state,
                departmentIDPK: action.payload
            };
        case "department":
            return {
                ...state,
                department: action.payload
            };
        case "requestTypeIDPK":
            return {
                ...state,
                requestTypeIDPK: action.payload
            };
        case "requestType":
            return {
                ...state,
                requestType: action.payload
            };
        case "subject":
            return {
                ...state,
                subject: action.payload,
            };
        case "others":
            return {
                ...state,
                others: action.payload,
            };
        case "description":
            return {
                ...state,
                description: action.payload,
            };
        case "RequesterName":
            return {
                ...state,
                RequesterName: action.payload,
            };
        case "Email":
            return {
                ...state,
                Email: action.payload,
            };
        case "ContactNumber":
            return {
                ...state,
                ContactNumber: action.payload,
            };
        default:
            return state;
    }
};

const initialState = {
    departmentIDPK: '',
    department: '',
    requestTypeIDPK: '',
    requestType: '',
    others: '',
    subject: '',
    RequesterName: '',
    Email: '',
    ContactNumber: '',
    description: ''
}

export default function RaiseTicket({ handleRTclose, fromHome, departmentIDPK, department }) {

    const [state, dispatch] = useReducer(departmentReducer, initialState);
    const [departmentList, setDepartmentList] = useState([]);
    const [requestTypeList, setRequestTypeList] = useState([]);
    const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);
    const [isRequestTypeOpen, setIsRequestTypeOpen] = useState(false);
    const SubjectRef = useRef(null);
    const OthersRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [convertedAttach, setConvertAttach] = useState([]);
    const Scrollview = useRef(null);
    const [isCreating, setIsCreating] = useState(false);

    useEffect(() => {
        if (fromHome && departmentIDPK && department) {
            dispatch({ type: 'departmentIDPK', payload: departmentIDPK });
            dispatch({ type: 'department', payload: department });
        }
    }, [fromHome, departmentIDPK, department]);

    useEffect(() => {
        if (files && files.length > 0) {
            convertFilesToBase64(files).then((result) => {
                setConvertAttach(result);
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
    }, [files])

    useEffect(() => {
        if (Scrollview.current) {
            Scrollview.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [files]);

    const removeSingleQuotes = (text) => {
        if (!text) return text;
        return text.replace(/'/g, '');
    };

    function convertFilesToBase64(fileList) {
        const base64ArrayPromises = Array.from(fileList).map((file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = function (event) {
                    resolve({
                        base64data: event.target.result.split(',')[1],
                        filename: file.name,
                        type: file.name
                        // type: file.type.split('/')[1]
                    });
                };

                reader.onerror = function (error) {
                    reject(error);
                };

                reader.readAsDataURL(file);
            });
        });
        return Promise.all(base64ArrayPromises);
    }

    const clear = () => {
        dispatch({ type: "departmentIDPK", payload: '' })
        dispatch({ type: "department", payload: '' })
        dispatch({ type: "requestTypeIDPK", payload: '' })
        dispatch({ type: "requestType", payload: '' })
        dispatch({ type: "others", payload: '' })
        dispatch({ type: "subject", payload: '' })
        dispatch({ type: "description", payload: '' })
        dispatch({ type: "Email", payload: '' })
        dispatch({ type: "ContactNumber", payload: '' })
    }

    // ******************** Department Dropdown section  start ********************
    useEffect(() => {
        handleDepartmentList();
        handleRequestTypeList();
    }, [])

    const handleDepartmentList = async () => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 3,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const {
            Output: { status, data },
        } = response;
        if (response.Output.status.code == "200") {
            setDepartmentList(data || []);
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const handleRequestTypeList = async () => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 7,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const {
            Output: { status, data },
        } = response;
        if (response.Output.status.code == "200") {
            setRequestTypeList(data || []);
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const handleDepartmentClick = (id, val) => {
        dispatch({ type: 'departmentIDPK', payload: id });
        dispatch({ type: 'department', payload: val });
        setIsDepartmentOpen(false);
        if (id != 1) {
            SubjectRef.current.focus();
        }
    };

    const handleRequestClick = (id, val) => {
        dispatch({ type: 'requestTypeIDPK', payload: id });
        dispatch({ type: 'requestType', payload: val });
        setIsRequestTypeOpen(false);
        if (val == 'Others') {
            setTimeout(() => {
                OthersRef.current.focus();
            }, 500)
        } else {
            SubjectRef.current.focus();
        }
    };

    const handleDepartmentChange = (event) => {
        dispatch({ type: 'department', payload: event.target.value });
        setIsDepartmentOpen(true);
    };

    const handleRequestChange = (event) => {
        dispatch({ type: 'requestType', payload: event.target.value });
        setIsRequestTypeOpen(true);
    };

    const DepartmentToggleDropdown = () => {
        setIsDepartmentOpen((prevState) => !prevState);
    };

    const RequestToggleDropdown = () => {
        setIsRequestTypeOpen((prevState) => !prevState);
    };

    const handleOutsideClick = (event) => {
        if (!event.target.closest('.dropdown')) {
            setIsDepartmentOpen(false);
            setIsRequestTypeOpen(false);
        }
    };

    const filteredList = departmentList.filter(
        (val) =>
            val.PortalDeptTypeName &&
            val.PortalDeptTypeName.toLowerCase().includes(state.department.toLowerCase())
    );

    const filteredList2 = requestTypeList.filter(
        (val) =>
            val.ClientReqName &&
            val.ClientReqName.toLowerCase().includes(state.requestType.toLowerCase())
    );

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    // ******************** Department Dropdown section  End ********************

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validation = () => {
        if (isCreating) return;
        if (!state.department) {
            toast.warning('Kindly select the department');
            return;
        }
        if (state.departmentIDPK == 1 && !state.requestType) {
            toast.warning('Kindly select the request type');
            return;
        }
        if (state.departmentIDPK == 1 && state.requestTypeIDPK == 8 && !state.others) {
            toast.warning('Kindly enter a describe for others');
            return;
        }
        if (!state.subject) {
            toast.warning('Kindly enter the subject');
            return;
        }
        if (!state.description) {
            toast.warning('Kindly enter the description');
            return;
        }
        if (state.Email && !isValidEmail(state.Email)) {
            toast.warning('Please enter a valid email address');
            return;
        }
        setIsCreating(true);
        handleRaiseTasksave();
    }

    const handleRaiseTasksave = async () => {
        try {
            const response = await getData("VwAPINSEIPLClientPortal/", {
                data: {
                    p1_int: 2,
                    // p2_int: 0,
                    // p3_int: 0,
                    p4_int: state.departmentIDPK ? state.departmentIDPK : null,
                    // p5_int: 0,
                    // p6_int: 0,
                    // p7_int: 0,
                    // p8_date: null,
                    p9_varchar: state.subject ? removeSingleQuotes(state.subject) : null,
                    p10_varchar: state.description ? removeSingleQuotes(state.description) : null,
                    UserID_int: localStorage.getItem("EmpID"),
                    // ProjectID_int: 0,
                    // TaskTypeID_int: 0,
                    // TypeID_int: 0,
                    // Remarks1: null,
                    // Remarks2: null,
                    // Remarks3: null
                },
            });
            const { Output: { status, data } } = response;
            if (response.Output.status.code == "200") {
                clear();
                handleRTclose();
                if (state.departmentIDPK == 1) {
                    RaiseTaskRequestTypeSave(data[0].ComplaintIDPK);
                }
                if (state.Email || state.ContactNumber) {
                    RaiseTaskContactSave(data[0].ComplaintIDPK);
                }
                if (convertedAttach && convertedAttach.length > 0) {
                    AttachSave(convertedAttach, data[0].ComplaintIDPK, 1);
                }
                toast.success(`Task No ${data[0].ComplaintNo} raised successfully`);
            } else {
                console.error("Error fetching data:", status.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setIsCreating(false);
        }
    };

    const RaiseTaskRequestTypeSave = async (ComplaintIDPK) => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 8,
                p2_int: ComplaintIDPK ? Number(ComplaintIDPK) : null,
                p3_int: state.requestTypeIDPK ? Number(state.requestTypeIDPK) : null,
                p9_varchar: state.others ? removeSingleQuotes(state.others) : null,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status } } = response;
        if (response.Output.status.code == "200") {
            handleRTclose();
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const RaiseTaskContactSave = async (ComplaintIDPK) => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 9,
                p2_int: ComplaintIDPK ? Number(ComplaintIDPK) : null,
                p9_varchar: state.Email ? removeSingleQuotes(state.Email) : null,
                p10_varchar: state.ContactNumber ?? null,
                UserID_int: localStorage.getItem("EmpID"),
                Remarks1:  state.RequesterName ?? null
            },
        });
        const { Output: { status } } = response;
        if (response.Output.status.code == "200") {
            handleRTclose();
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleRemoveFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    const handleFilePreview = (file) => {
        if (file.type.startsWith("image/")) {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else if (file.type === "application/pdf") {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else {
            alert("Preview not supported for this file type");
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    async function AttachSave(ImageArray, TaskIDPK, ModID) {
        const url = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/imageupload.php';

        try {
            await Promise.all(ImageArray.map(async (param) => {
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(param),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };

                const response = await fetch(url, requestOptions);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const responseData = await response.json();
                const imagePath = responseData.filename;

                const url2 = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/AdminImageRegistry.php';
                const formData = {
                    "AdminImageIDPK_int": "",
                    "ImageCode_varchar": "",
                    "ImageName_varchar": param.filename,
                    "ImgActualSize_varchar": "",
                    "ImgCompressSize_varchar": "",
                    "ImageSource_image": "",
                    "ImgPath_varchar": imagePath,
                    "ImgType_varchar": "png",
                    "TransType_varchar": "",
                    "ImgProType_int": "",
                    "IsDefault_bit": "",
                    "IsDraft_bit": "",
                    "Remarks_varchar": "",
                    "TransID_int": Number(TaskIDPK),
                    "ModFormID_int": ModID ?? null,
                    "TransTypeID_int": "",
                    "IsActive_bit": "1",
                    "DeleStat_bit": "",
                    "CreatedUserID_int": "",
                    "CreatedTtm_datetime": "",
                    "UpdatedUserID_int": "",
                    "UpdatedTtm_datetime": ""
                };

                const requestOptions2 = {
                    method: 'POST',
                    body: JSON.stringify(formData),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };

                const response2 = await fetch(url2, requestOptions2);
                if (!response2.ok) {
                    throw new Error('Network response was not ok');
                }
            }));
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <div className="RaisedTicketPageParent" onDrop={handleDrop}
            onDragOver={handleDragOver}>
            <div className="RTheadingSec">
                <span className="RTmodalHeadingText">Create a ticket</span>
                <IoCloseOutline className="IoCloseStyle" onClick={handleRTclose} />
            </div>

            <div className="RTinputParentDiv">
                <div className="RTinputFieldParent">

                    <div className={state.departmentIDPK == 1 ? "RTinputFieldDiv" : "RTinputFieldFullDiv"}>
                        <span className="RTinputLabel">
                            Department<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </span>

                        <div className="dropdown InputFieldMainDiv" style={{ position: 'relative' }}>
                            <input
                                type="text"
                                value={state.department}
                                onChange={handleDepartmentChange}
                                onClick={DepartmentToggleDropdown}
                                placeholder="Select department"
                                className='SelectEmpInput'
                            />

                            {isDepartmentOpen ? <IoIosArrowUp className='RSslectArrowIcon' /> :
                                <IoIosArrowDown className='RSslectArrowIcon' />}

                            {state.department && (
                                <IoCloseOutline
                                    onClick={() => {
                                        setIsDepartmentOpen(false);
                                        dispatch({ type: 'departmentIDPK', payload: '' });
                                        dispatch({ type: 'department', payload: '' });
                                        dispatch({ type: 'requestTypeIDPK', payload: '' });
                                        dispatch({ type: 'requestType', payload: '' });
                                        dispatch({ type: "others", payload: '' })
                                    }}
                                    className='RSslectClearIcon'
                                />
                            )}

                            {isDepartmentOpen && (
                                <div
                                    className="SelectEmpDropDown"
                                >
                                    {filteredList.length > 0 ? (
                                        filteredList.map((item) => (
                                            <div
                                                key={item.PortalDeptTypeIDPK}
                                                onClick={() => {
                                                    handleDepartmentClick(item.PortalDeptTypeIDPK, item.PortalDeptTypeName);
                                                }}
                                                className='SelectEmpDropDownList'
                                            >
                                                {item.PortalDeptTypeName}
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ padding: '10px' }}>No results</div>
                                    )}

                                </div>
                            )}
                        </div>
                    </div>

                    {state.departmentIDPK == 1 &&
                        <div className="RTinputFieldDiv">
                            <span className="RTinputLabel">
                                Request Type<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                            </span>

                            <div className="dropdown InputFieldMainDiv" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={state.requestType}
                                    onChange={handleRequestChange}
                                    onClick={RequestToggleDropdown}
                                    placeholder="Select request type"
                                    className='SelectEmpInput'
                                />

                                {isRequestTypeOpen ? <IoIosArrowUp className='RSslectArrowIcon' /> :
                                    <IoIosArrowDown className='RSslectArrowIcon' />}

                                {state.requestType && (
                                    <IoCloseOutline
                                        onClick={() => {
                                            setIsRequestTypeOpen(false);
                                            dispatch({ type: 'requestTypeIDPK', payload: '' });
                                            dispatch({ type: 'requestType', payload: '' });
                                            dispatch({ type: "others", payload: '' })
                                        }}
                                        className='RSslectClearIcon'
                                    />
                                )}

                                {isRequestTypeOpen && (
                                    <div
                                        className="SelectEmpDropDown"
                                    >
                                        {filteredList2.length > 0 ? (
                                            filteredList2.map((item) => (
                                                <div
                                                    key={item.ClientReqTypeIDPK}
                                                    onClick={() => {
                                                        handleRequestClick(item.ClientReqTypeIDPK, item.ClientReqName);
                                                    }}
                                                    className='SelectEmpDropDownList'
                                                >
                                                    {item.ClientReqName}
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ padding: '10px' }}>No results</div>
                                        )}

                                    </div>
                                )}
                            </div>
                        </div>}

                    {state.requestTypeIDPK == 8 && <div className="RTinputFieldFullDiv">
                        <span className="RTinputLabel">
                            Describe For Others<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </span>

                        <div className="InputFieldMainDiv">
                            <input
                                ref={OthersRef}
                                type="text"
                                placeholder="Describe for others"
                                className="RTSelectInputField"
                                value={state.others}
                                onChange={(e) => dispatch({ type: "others", payload: e.target.value })}
                            />

                            {state.others && <span className="SelectArrowDiv">
                                <IoCloseOutline className="IoCloseOutlineStyle" onClick={() => dispatch({ type: "others", payload: '' })} />
                            </span>}
                        </div>
                    </div>}

                    <div className="RTinputFieldFullDiv">
                        <span className="RTinputLabel">
                            Subject<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </span>

                        <div className="InputFieldMainDiv">
                            <input
                                ref={SubjectRef}
                                type="text"
                                placeholder="Enter a subject here"
                                className="RTSelectInputField"
                                value={state.subject}
                                onChange={(e) => dispatch({ type: "subject", payload: e.target.value })}
                            />

                            {state.subject && <span className="SelectArrowDiv">
                                <IoCloseOutline className="IoCloseOutlineStyle" onClick={() => dispatch({ type: "subject", payload: '' })} />
                            </span>}
                        </div>
                    </div>
                </div>

                <div className="RTinputFieldDiv1">
                    <span className="RTinputLabel">
                        Description<span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                    </span>

                    <textarea
                        placeholder="Enter a description here"
                        className="RTtextAreaInputField"
                        value={state.description}
                        onChange={(e) => dispatch({ type: "description", payload: e.target.value })}
                    ></textarea>
                </div>

                <div className="AttachmentParentDiv">
                    <div className="AttachmentheadingSec">
                        <div className="AttachmentTextSec">
                            <RiAttachment2 className="IoAttachSharpStyle" />
                            <span className="AttTxtSty">Attachment</span>
                            <span className="AttachLimitCount">({files && files.length})</span>
                        </div>
                        <label htmlFor="fileInput" className="UploadBtn">
                            Upload
                            <input
                                type="file"
                                multiple
                                style={{ display: "none" }}
                                id="fileInput"
                                onChange={handleFileChange}
                            />
                        </label>
                    </div>

                    <div className="DropDropParentDiv">
                        <span className="DNDtext">Drag and Drop</span>
                    </div>
                </div>

                {files.length > 0 && <div style={styles.FileList}>
                    {files.map((file) => (
                        <div
                            key={file.name}
                            style={styles.FileItem}
                            onDoubleClick={() => handleFilePreview(file)}
                        >
                            <div style={styles.FileName}>{file.name}</div>
                            <AiOutlineClose
                                style={styles.CloseIcon}
                                onClick={() => handleRemoveFile(file.name)}
                            />
                        </div>
                    ))}
                </div>}

                {files.length > 0 && <div ref={Scrollview}></div>}

                <div className="RTinputFieldDiv1">
                    <span className="RTinputLabel">Requestor Name</span>

                    <div className="InputFieldMainDiv">
                        <input
                            type="text"
                            placeholder="Enter a requester name"
                            className="RTSelectInputField"
                            value={state.RequesterName}
                            onChange={(e) => dispatch({ type: "RequesterName", payload: e.target.value })}
                        />

                        {state.RequesterName && <span className="SelectArrowDiv">
                            <IoCloseOutline className="IoCloseOutlineStyle" onClick={() => dispatch({ type: "RequesterName", payload: '' })} />
                        </span>}
                    </div>
                </div>

                <div className="RTinputFieldParent1">
                    <div className="RTinputFieldDiv">
                        <span className="RTinputLabel">Requestor Email</span>

                        <div className="InputFieldMainDiv">
                            <input
                                type="text"
                                placeholder="Enter a email"
                                className="RTSelectInputField"
                                value={state.Email}
                                onChange={(e) => dispatch({ type: "Email", payload: e.target.value })}
                            />

                            {state.Email && <span className="SelectArrowDiv">
                                <IoCloseOutline className="IoCloseOutlineStyle" onClick={() => dispatch({ type: "Email", payload: '' })} />
                            </span>}
                        </div>
                    </div>

                    <div className="RTinputFieldDiv">
                        <span className="RTinputLabel">Requestor Contact Number</span>

                        <div className="InputFieldMainDiv">
                            <input
                                type="text"
                                placeholder="Enter a contact number"
                                className="RTSelectInputField"
                                value={state.ContactNumber}
                                // onChange={(e) => dispatch({ type: "ContactNumber", payload: e.target.value })}
                                maxLength={15}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        dispatch({ type: "ContactNumber", payload: value });
                                    }
                                }}
                            />

                            {state.ContactNumber && <span className="SelectArrowDiv">
                                <IoCloseOutline className="IoCloseOutlineStyle" onClick={() => dispatch({ type: "ContactNumber", payload: '' })} />
                            </span>}
                        </div>
                    </div>
                </div>

            </div>

            <div className="RTfooterSec">
                <Button variant="contained" className="DiscardButton" onClick={() => { handleRTclose(); clear(); }} >
                    Discard</Button>

                <Button variant="contained" className="CreateBtnSty" onClick={validation}
                    disabled={isCreating} >
                    {isCreating ? "Creating..." : "Create"}</Button>
            </div>

        </div>
    )
}
